import React, {useState} from 'react'
import avt from "../../../../statics/assets/images/extrasmall.png"
import {removeLocalData} from "../../../../services/StorageServices"
import {logoutPhone} from "../../../../services/api/apiPhoneConnect"
import {Link} from "react-router-dom"
import _checkRoles from "../../../../helpers/checkRole"
import {resetListRoles} from "../../../../store/action"
import {connect} from "react-redux"
import parseToken from "../../../../helpers/parseToken"

function UserAction(props) {
    const {resetRoles} = props
    const decodeToken = parseToken()
    const [isOpen, setIsOpen] = useState(false)

    const _onOpenMenu = () => {
        setIsOpen(true)
    }

    const _onCloseMenu = () => {
        setIsOpen(false)
    }

    const _onClearData = async () => {
        await _onLogout()
        await removeLocalData('accessToken')
        await removeLocalData('apiKey')
        window.location.href = `https://admin.callstack.vn:2008/passportv3/logout?service=https://admin.callstack.vn`
    }
    const _onLogout = async () => {
        try {
            resetRoles()
            removeLocalData('roles')

            const payload = {
                vsaUser: decodeToken.sub,
            }

            const response = await logoutPhone(payload)

            const {success, error_message} = response

            if (success !== '1') {
                return console.log(error_message)
            }

            removeLocalData('loginPhoneKey')
            removeLocalData('userLoginPhone')
            removeLocalData('ipPhone')
            removeLocalData('status')
            removeLocalData('leadFilter')
            removeLocalData('leadTable')
            removeLocalData('logoTenant')
            removeLocalData('dialogs')
            removeLocalData('tabs')
            removeLocalData('tabsNotChange')
            removeLocalData('tabActive')
        } catch (e) {
            console.log(e.message)
        }
    }

    return (
        <div className="UserAction">
            <div className="nav-link">
                <img src={avt} alt="avt" onClick={_onOpenMenu}/>
                <span>{decodeToken.sub}</span>
            </div>

            <div className="Action">
                <ul className={`ListActions ${isOpen ? 'Open' : ''}`}>
                    {
                        _checkRoles('menu.user.userSetting') && <li>
                            <Link to={'/crm/users'} className="nav-link">Settings</Link>
                        </li>
                    }
                    <li onClick={_onClearData}>
                        <span className="nav-link not-border">Logout</span>
                    </li>
                </ul>
                {isOpen && <div className="Background" onClick={_onCloseMenu}/>}
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {resetRoles: (roles) => dispatch(resetListRoles(roles))};
};

export default connect(null, mapDispatchToProps)(UserAction)
